import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  Col,
  Row,
  Spin,
  Table,
  Upload,
  Modal,
  Space,
  Input,
  Form,
} from "antd";
import { ColumnsImportData, ColumnsImportDataCsv } from "./columns-table";
import { notificationErroInternal, notificationSucess } from "util/api-utils";
import {
  deleteFileImported,
  getFiles,
  saveCashFlow,
} from "services/import/import-service";
import { ExclamationCircleFilled, SearchOutlined } from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import { CSVLink } from "react-csv";

const { confirm } = Modal;

const ImportData = () => {
  const [loadingData, setLoadingData] = useState(true);
  const [data, setData] = useState([]);
  const [fileList, setFileList] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = React.useRef(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const formRef = React.useRef(null);

  const handleUpload = (observation) => {
    setUploading(true);
    const formData = new FormData();
    formData.append("file", fileList[0]);
    formData.append("observation", observation);

    saveCashFlow(formData)
      .then(() => {
        setUploading(false);
        notificationSucess();
        getFilesData();

        setFileList([]);
      })
      .catch((err) => {
        setUploading(false);
        notificationErroInternal(
          "Aconteceu um erro inesperado, por favor, tente mais tarde."
        );
      });
  };
  const props = {
    onRemove: (file) => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      setFileList(newFileList);
    },
    beforeUpload: (file) => {
      setFileList([...fileList, file]);
      return false;
    },
    fileList,
  };

  function disable(row) {
    confirm({
      title: "Tem certeza que deseja deletar arquivo importado ?",
      icon: <ExclamationCircleFilled />,
      okText: "Sim",
      okType: "danger",
      cancelText: "Não",
      onOk() {
        setLoadingData(true);
        deleteFileImported(row.id)
          .then(() => {
            notificationSucess();
            getFilesData();
          })
          .catch((err) => {
            setLoadingData(false);
            notificationErroInternal(
              "Aconteceu um erro inesperado, por favor, tente mais tarde."
            );
          });
      },
      onCancel() {},
    });
  }

  useEffect(() => {
    setLoadingData(false);
    getFilesData();
  }, []);

  function getFilesData() {
    getFiles()
      .then((res) => {
        setLoadingData(false);
        res = res.map((obj) => ({ ...obj, disable: disable }));

        setData(res);
      })
      .catch((err) => {
        setLoadingData(false);
        notificationErroInternal(
          "Aconteceu um erro inesperado, por favor, tente mais tarde."
        );
      });
  }

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };

  const getColumnSearchProps = (dataIndex, tittle) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`Buscar ${tittle}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: "block",
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Buscar
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            Limpar
          </Button>

          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            Fechar
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? "#1890ff" : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: "#ffc069",
            padding: 0,
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    formRef.current
      .validateFields()
      .then((values) => {
        handleUpload(values.observation);
        setIsModalOpen(false);
        formRef.current?.resetFields();
      })
      .catch((errors) => {
        console.log(errors);
      });
  };
  const handleCancel = () => {
    formRef.current?.resetFields();
    setIsModalOpen(false);
  };

  let columnFilter = ColumnsImportData.filter(
    (item) => item.dataIndex != "action"
  ).map((item) => ({
    ...item,
    ...getColumnSearchProps(item.dataIndex, item.title),
  }));
  const action = ColumnsImportData.filter((item) => item.dataIndex == "action");
  columnFilter.push(action[0]);

  return (
    <div className="container-client">
      <Card
        className="card-client"
        title="Importação de dados"
        extra={
          <div>
            <Space>
              <CSVLink
                filename={"importacoes.csv"}
                className="btn btn-primary"
                data={data}
                headers={ColumnsImportDataCsv}
                style={{ borderRadius: "6px" }}
              >
                Baixar
              </CSVLink>

              <a href="https://bussola-web.s3.amazonaws.com/importacao_dados.xlsx">
                <Button
                  style={{
                    display: fileList.length !== 0 ? "none" : "",
                  }}
                  type="primary"
                >
                  Baixar templete
                </Button>
              </a>

              <Upload {...props}>
                <Button
                  style={{
                    marginRight: "-9px",
                    display: fileList.length !== 0 ? "none" : "",
                  }}
                  type="primary"
                  className="button-user"
                  onClick={() => {}}
                >
                  Nova Importação
                </Button>
              </Upload>
              <Button
                loading={uploading}
                type="primary"
                onClick={showModal}
                disabled={fileList.length === 0}
                style={{
                  display: fileList.length === 0 ? "none" : "",
                }}
              >
                {"Salvar arquivo"}
              </Button>
            </Space>
          </div>
        }
        bordered={false}
      >
        <Spin spinning={loadingData} size={"large"}>
          <Table
            columns={columnFilter}
            dataSource={data}
            pagination={{ pageSize: 10 }}
            locale={{
              emptyText: "Sem registro",
            }}
          />
        </Spin>
      </Card>

      <Modal
        style={{ textAlign: "center" }}
        title="Salvar Importação"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <Form ref={formRef} style={{ maxWidth: 600 }}>
          <Form.Item
            name="observation"
            label="Observação"
            rules={[
              {
                required: true,
                message: "É necessário informar uma observação",
              },
            ]}
          >
            <Input style={{ width: "94%", marginLeft: "10px" }} />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};
export default ImportData;
